<mat-checkbox
  class="mat-option all-checkbox"
  [indeterminate]="isIndeterminate()"
  [checked]="isChecked()"
  (click)="$event.stopPropagation()"
  (change)="toggleSelection($event)">
  {{text}}
</mat-checkbox>
